// @flow
import React, {Component} from 'react';
import { connect } from 'react-redux';
import CampaignsForm from '../../components/Campaigns/campaignsForm';
import handleImageInput from '../../helpers/image/handleImageInput';
import {
  clearCampaignsForm,
  clearTempUploadedCampaign,
  createCampaign,
  storeTemporaryCampaignImage
} from '../../actions/campaigns';
import { parseProducts } from '../../helpers/parseImmutables';

class CampaignsFormHOC extends Component {
  state = {
    title: '',
    description: '',
    warning: undefined,
    productId: undefined,
  };

  componentDidMount() {
    this.props.clearCampaignsForm();
  }

  setField = (name, value) => {
    this.setState({
      [name]: value,
    })
  };

  setSelectedProduct = (productId) => {
    this.setState({
      productId: productId,
    })
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (!this.state.title.length) {
      this.setState({ warning: 'Please give a name to the campaign!' });
      return false;
    }

    this.props.createCampaign({
      title: this.state.title,
      description: this.state.description,
      logo: this.props.tempImage,
      featuredProductId: this.state.productId.value,
    })
  };

  clearWarning = () => {
    this.setState({warning: undefined});
  };

  render() {
    const {
      navigation, storeTemporaryCampaignImage, tempImage, clearCampaign
    } = this.props;
    return (
      <CampaignsForm
        title={this.state.title}
        description={this.state.description}
        logo={this.state.logo}
        formWarningOpen={this.state.warning}
        clearWarning={this.clearWarning}
        setField={this.setField}
        handleSubmit={this.handleSubmit}
        handleImageInput={handleImageInput}
        storeTemporaryCampaignImage={storeTemporaryCampaignImage}
        tempImage={tempImage}
        clearTempUploadedCampaign={clearCampaign}
        setSelectedProduct={this.setSelectedProduct}
        products={this.props.allProducts}
        featuredProduct={this.state.productId}
      />
    );
  }
}

const mapStateToProps = state => ({
  tempImage: state.campaigns.get('tempImage'),
  allProducts: parseProducts(state.products).all,
});

const mapDispatchToProps = dispatch => ({
  clearCampaignsForm: (payload) => {
    dispatch(clearCampaignsForm(payload))
  },
  clearCampaign: (payload) => {
    dispatch(clearTempUploadedCampaign(payload))
  },
  createCampaign: (payload) => {
    dispatch(createCampaign(payload))
  },
  storeTemporaryCampaignImage: (payload) => {
    dispatch(storeTemporaryCampaignImage(payload))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignsFormHOC);



// WEBPACK FOOTER //
// ./src/containers/Campaigns/CampaingsFormHOC.js